export default function getImageTypeFromBase64(base64string) {
  if (base64string.substring(0,20) === '/9j/4AAQSkZJRgABAQAA') return 'image/jpeg';

  if (base64string.substring(0,25) === 'iVBORw0KGgoAAAANSUhEUgAAA') return 'image/png';

  if (window.atob(base64string).includes('<svg')) return 'image/svg+xml';

  return 'image/';
}